// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { ReactComponent as MyMatchIcon } from '../../assets/svg/mymatch.svg';
import { type BetBuilderItem } from '../../states/betbuilder';
import CardMyMatchContentItemContainer from '../BasketCardMyMatchContentItem/BasketCardMyMatchContentItemContainer';

const Wrap = styled.div`
  color: #fff;
  text-align: center;
  position: relative;
`;

const MyMatchLogo = styled(MyMatchIcon)`
  height: 1.3em;
  width: auto;
  margin: 0 auto;
  padding: 0.4em 0 0.2em 1.5em;
`;

const MyMatchContentItemsWrapper = styled.div``;

type BasketCardMyMatchContentProps = {
  className?: string;
  items: Array<BetBuilderItem>;
};

const BasketCardMyMatchContent = ({ className, items }: BasketCardMyMatchContentProps) => {
  return (
    <Wrap className={className}>
      <MyMatchLogo />
      <MyMatchContentItemsWrapper>
        {items.map((item, idx) => (
          <CardMyMatchContentItemContainer
            {...item}
            key={item.outcomeIds ? item.outcomeIds.reduce((acc, curr) => `${acc}${curr}`, '') : item.outcomeId}
            nbItems={items.length}
            prevItem={items[idx - 1]}
          />
        ))}
      </MyMatchContentItemsWrapper>
    </Wrap>
  );
};

export default BasketCardMyMatchContent;
